(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-split"] && !Shopify.designMode) return;
  try {
    
  class HeroSplitCarousel extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('swiper')) return;

      if (typeof Swiper === 'undefined') {
        document.addEventListener('swiper:ready', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      if (this.swiperInstance) return;

      this.swiperInstance = new Swiper(this, {
        slidesPerView: 1,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        },
        on: {
          init: () => {
            this.classList.add('is-swiper-initialized');
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy();
        this.swiperInstance = null;
      }
    }
  }

  if (!customElements.get('hero-split-carousel')) {
    customElements.define('hero-split-carousel', HeroSplitCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newbar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const customFeatureBar = new Swiper('.hero-slider', {
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      slidesPerView: 3,
      spaceBetween: 30,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        769: {
          slidesPerView: 2,
        },
        990: {
          slidesPerView: 3,
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
  class TrustBarCarousel extends HTMLElement {
    connectedCallback() {
      this.swiperEl = this.querySelector('.swiper');
      if (!this.swiperEl) return;

      if (typeof Swiper === 'undefined') {
        document.addEventListener('swiper:ready', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      if (this.swiperInstance) return;

      const autoplay = this.dataset.autoplay === 'true'
        ? { delay: 4000, disableOnInteraction: false }
        : false;

      // One slide at a time on mobile (with autoplay, if enabled); wider
      // screens show more items per view at once instead of forcing every
      // item into an equal-width column regardless of how much text it
      // holds — Swiper owns slide width/spacing at every breakpoint so
      // items never overflow into one another.
      this.swiperInstance = new Swiper(this.swiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        autoplay,
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 24,
            autoplay: false
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 32,
            autoplay: false
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }
  }

  if (!customElements.get('trust-bar-carousel')) {
    customElements.define('trust-bar-carousel', TrustBarCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
